/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsAcceptAodRunRunActionsMutationRequest, AuditReportsAcceptAodRunRunActionsMutationResponse, AuditReportsAcceptAodRunRunActionsPathParams, AuditReportsAcceptAodRunRunActions400, AuditReportsAcceptAodRunRunActions401, AuditReportsAcceptAodRunRunActions403, AuditReportsAcceptAodRunRunActions404 } from "../models/AuditReportsAcceptAodRunRunActions";

export function getAuditReportsAcceptAodRunRunActionsUrl(id: AuditReportsAcceptAodRunRunActionsPathParams["id"]) {
  const res = { method: 'PUT', url: `/audit-reports/v1/aod-runs/${id}/accept` as const }
  return res
}

/**
 * @description Re-executes the AOD run job with minimum efficiency requirement removed for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Accept a run
 * {@link /audit-reports/v1/aod-runs/:id/accept}
 */
export async function auditReportsAcceptAodRunRunActions(id: AuditReportsAcceptAodRunRunActionsPathParams["id"], data: AuditReportsAcceptAodRunRunActionsMutationRequest, config: Partial<RequestConfig<AuditReportsAcceptAodRunRunActionsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsAcceptAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsAcceptAodRunRunActions400 | AuditReportsAcceptAodRunRunActions401 | AuditReportsAcceptAodRunRunActions403 | AuditReportsAcceptAodRunRunActions404>, AuditReportsAcceptAodRunRunActionsMutationRequest>({ method : "PUT", url : getAuditReportsAcceptAodRunRunActionsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}